module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns-house_spot_01-45314fe15ec03637f16a2d15b326e6c4.jpg";